import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}

const SEO = ({
  title = "LICO - Learn and Innovate Technologies Limited",
  description = "LICO provides expert business and tech training, entrepreneurship development, sustainable energy solutions, and real estate services across Nigeria. Based in Enugu, serving businesses nationwide. Transform your future with our comprehensive solutions.",
  keywords = "LICO, business training Nigeria, tech training Nigeria, entrepreneurship development, solar energy Nigeria, solar energy Enugu, software development Nigeria, real estate Nigeria, real estate Enugu, technical training, renewable energy solutions, custom software, property investment Nigeria, Learn and Innovate, New Heaven Enugu, business skills training, leadership training, startup support, construction services Nigeria",
  ogImage = "https://learnandinnovatespace.com/lico-og-image.png",
  ogType = "website",
  canonical = "https://learnandinnovatespace.com/",
}: SEOProps) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />

      {/* Canonical */}
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};

export default SEO;
